
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Dark atmospheric background */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0a0a] to-[#1a1a1a]"></div>
      
      {/* Moody lighting effects - like street lights in a dark alley */}
      <div className="absolute top-20 left-10 w-[600px] h-[600px] bg-[#F6B766]/10 rounded-full blur-[120px] opacity-40"></div>
      <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-[#F4A259]/8 rounded-full blur-[100px] opacity-30"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#D4A574]/5 rounded-full blur-[150px]"></div>

      {/* Subtle grain texture overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxwYXRoIGQ9Ik0wIDBoMzAwdjMwMEgweiIgZmlsdGVyPSJ1cmwoI2EpIiBvcGFjaXR5PSIuMDUiLz48L3N2Zz4=')]"></div>

      <div className="relative z-10 container mx-auto px-6 max-w-7xl">
        <div className="text-center space-y-8">
          <div className="space-y-6">
            <div className="flex items-center justify-center">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#F6B766]/50"></div>
              <span className="mx-4 text-[#F6B766]/70 text-sm tracking-[0.3em] uppercase">The Broker</span>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#F6B766]/50"></div>
            </div>
            
            <h1 className="text-6xl lg:text-7xl font-light text-white leading-tight">
              게임을 세계에<br />
              <span className="text-[#F6B766]">퍼뜨리는</span> 힘
            </h1>
            
            <p className="text-xl text-white/60 max-w-2xl mx-auto font-light leading-relaxed">
              당신의 게임이 자연스럽게 전세계로 확산되도록 돕습니다
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/#contact')}
              className="bg-gradient-to-r from-[#F6B766] to-[#F4A259] text-black px-8 py-4 rounded-lg hover:shadow-lg hover:shadow-[#F6B766]/20 transition-all font-semibold whitespace-nowrap cursor-pointer"
            >
              프로젝트 시작하기
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/portfolio')}
              className="px-8 py-4 border border-white/20 text-white hover:border-[#F6B766]/50 hover:text-[#F6B766] transition-all rounded-lg whitespace-nowrap cursor-pointer"
            >
              포트폴리오 보기
            </button>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#1a1a1a] to-transparent"></div>
    </section>
  );
}
